/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateClientRequest } from '../models/CreateClientRequest';
import type { CreateResponse } from '../models/CreateResponse';
import type { GetClientResponse } from '../models/GetClientResponse';
import type { PageableClientResponse } from '../models/PageableClientResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create client
   * @param requestBody Create client body schema
   * @returns CreateResponse Success create response
   * @throws ApiError
   */
  public createClient(
    requestBody?: CreateClientRequest,
  ): CancelablePromise<CreateResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/clients/',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get all clients
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns PageableClientResponse Get client response
   * @throws ApiError
   */
  public getClients(
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<PageableClientResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/clients',
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get client by id
   * @param id
   * @returns GetClientResponse Get client response
   * @throws ApiError
   */
  public getClientById(
    id: string,
  ): CancelablePromise<GetClientResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/clients/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * delete client by id
   * @param id
   * @returns any delete client response
   * @throws ApiError
   */
  public deleteClientById(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/clients/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

}
